<template>
	<v-container grid-list-md>
		<v-card>
			<v-card-title primary-title>
				<v-btn
					icon
					@click="
						$inertia.visit(
							$route('central.drivers.index', $page.props)
						)
					"
					><v-icon>mdi-arrow-left</v-icon></v-btn
				>
				{{ $t("title.show_driver") }}
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 md3>
						<v-card width="300" height="auto">
							<v-container> </v-container>
							<h2 class="ml-6">
								{{ $t("label.profile") }}
							</h2>
							<v-list-item-content>
								<div class="mx-auto text-center">
									<v-avatar
										color="brown"
										width="120"
										height="120"
									>
										<v-img
											:src="
												driver
													? driver.image_url
													: '/images/image_placeholder.jpg'
											"
											style="h-2, min-w-2"
										></v-img>
									</v-avatar>
									<h2 class="pt-4">
										{{ driver.name }}
									</h2>
								</div>
							</v-list-item-content>
							<v-list nav dense>
								<v-list-item-group
									v-model="selectedItem"
									color="primary"
								>
									<v-list-item>
										<v-list-item-icon>
											<v-icon color="dark darken-2">
												mdi-phone
											</v-icon>
										</v-list-item-icon>
										<v-list-item-title
											class="font-weight-black"
											v-text="driver.phone"
										></v-list-item-title>
									</v-list-item>
								</v-list-item-group>
							</v-list>
						</v-card>
					</v-flex>
					<v-flex xs12 md9>
						<v-card>
							<v-container>
								<h2 class="pt-1 ml-6">
									{{ $t("label.information_driver") }}
								</h2>
								<v-row>
									<v-col cols="12" sm="6" md="6">
										<v-flex xs12 md11>
											<p class="text-caption ml-5 pt-5">
												{{ $t("Name") }}
											</p>
											<v-btn
												disabled
												block
												class="font-weight-black ml-5"
												>{{ driver.name }}
											</v-btn>
										</v-flex>
									</v-col>
									<v-col cols="12" sm="6" md="6">
										<v-flex xs12 md11>
											<p class="text-caption ml-5 pt-5">
												{{ $t("Code") }}
											</p>
											<v-btn
												disabled
												block
												class="font-weight-black ml-5"
												>{{ driver.code }}
											</v-btn>
										</v-flex>
									</v-col>
									<v-col cols="12" sm="6" md="6">
										<v-flex xs12 md11>
											<p class="text-caption ml-5">
												{{ $t("Phone") }}
											</p>
											<v-btn
												disabled
												block
												class="font-weight-black ml-5"
												>{{ driver.phone }}
											</v-btn>
										</v-flex>
									</v-col>
									<v-col cols="12" sm="11" md="11">
										<v-flex xs4 md4
											><p class="text-caption ml-5">
												{{ $t("Description") }}
											</p>

											<v-list-item-title
												class="
													mt-3
													pl-5
													font-weight-black
												"
												>{{
													driver.description
														? driver.description
														: "N/A"
												}}</v-list-item-title
											>
										</v-flex>
									</v-col>
								</v-row>
							</v-container>
						</v-card>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
export default {
	props: ["driver"],
	data() {
		return {
			selectedItem: 0,
		};
	},
};
</script>